export const articles = [
  {
    date: "2018.01.16",
    title: "🇰🇭Day1_柬埔寨｜暹粒(Siem Reap)：寺廟之城",
    url: "https://medium.com/cyen6/day1-%E6%9F%AC%E5%9F%94%E5%AF%A8-%E6%9A%B9%E7%B2%92-siem-reap-%E5%AF%BA%E5%BB%9F%E4%B9%8B%E5%9F%8E-4d3a1a1d49be",
    country: ["Cambodia"],
  },
  {
    date: "2018.01.17",
    title: "🇰🇭Day2_柬埔寨｜暹粒(Siem Reap)：高棉的微笑",
    url: "https://medium.com/cyen6/day2-%E6%9F%AC%E5%9F%94%E5%AF%A8-%E6%9A%B9%E7%B2%92-siem-reap-%E9%AB%98%E6%A3%89%E7%9A%84%E5%BE%AE%E7%AC%91-cd17d93e18bd",
    country: ["Cambodia"],
  },
  {
    date: "2018.01.18",
    title: "🇰🇭Day3_柬埔寨｜暹粒(Siem Reap)：雨林中的廢墟",
    url: "https://medium.com/cyen6/day3-%E6%9F%AC%E5%9F%94%E5%AF%A8-%E6%9A%B9%E7%B2%92-siem-reap-%E9%9B%A8%E6%9E%97%E4%B8%AD%E7%9A%84%E5%BB%A2%E5%A2%9F-ab403f05ed82",
    country: ["Cambodia"],
  },
  {
    date: "2018.12.25",
    title: "🇲🇲Day1_緬甸｜仰光(Yangon)：穿越時光隧道的金色國度",
    url: "https://medium.com/cyen6/day1-2018-12-25-%E5%8F%B0%E5%8C%97-%E6%9B%BC%E8%B0%B7-%E4%BB%B0%E5%85%89-yangon-92467edad0b5",
    country: ["Myanmar"],
  },
  {
    date: "2018.12.26",
    title: "🇲🇲Day2 _緬甸｜蒲甘(Bagan)：神居住的平原",
    url: "https://medium.com/cyen6/day2-2018-12-26-%E8%92%B2%E7%94%98-bagan-79e008fbbff1",
    country: ["Myanmar"],
  },
  {
    date: "2018.12.27",
    title: "🇲🇲Day3_緬甸｜蒲甘(Bagan)：在緬甸最愛的料理",
    url: "https://medium.com/cyen6/day3-%E7%B7%AC%E7%94%B8-%E8%92%B2%E7%94%98-bagan-%E7%B7%AC%E7%94%B8%E6%9C%80%E6%84%9B%E7%9A%84%E4%B8%80%E9%81%93%E6%96%99%E7%90%86-5587ef7a9d80",
    country: ["Myanmar"],
  },
  {
    date: "2018.12.28",
    title: "🇲🇲Day4_緬甸｜曼德勒(Mandalay)：記憶中的瓦城",
    url: "https://medium.com/cyen6/day4-%E7%B7%AC%E7%94%B8-%E6%9B%BC%E5%BE%B7%E5%8B%92-mandalay-%E8%A8%98%E6%86%B6%E4%B8%AD%E7%9A%84%E7%93%A6%E5%9F%8E-ae01ddf944d2",
    country: ["Myanmar"],
  },
  {
    date: "2018.12.29",
    title: "🇲🇲Day5_緬甸｜克勞(Kalaw)：Trekking in Kalaw",
    url: "https://medium.com/cyen6/day5-%E7%B7%AC%E7%94%B8-%E5%85%8B%E5%8B%9E-kalaw-trekking-in-kalaw-d74ebea718e0",
    country: ["Myanmar"],
  },
  {
    date: "2018.12.30",
    title: "🇲🇲Day6_緬甸｜茵萊湖(Inle Lake)：高原上的大海",
    url: "https://medium.com/cyen6/day6-%E7%B7%AC%E7%94%B8-%E8%8C%B5%E8%90%8A%E6%B9%96-inle-lake-%E9%AB%98%E5%8E%9F%E4%B8%8A%E7%9A%84%E5%A4%A7%E6%B5%B7-d40e80410c87",
    country: ["Myanmar"],
  },
  {
    date: "2018.12.31",
    title: "🇲🇲Day7_緬甸｜仰光(Yangon)：城市的對岸",
    url: "https://medium.com/cyen6/day7-%E7%B7%AC%E7%94%B8-%E4%BB%B0%E5%85%89-yangon-2ea4f57a4121",
    country: ["Myanmar"],
  },
  {
    date: "2019.09.07",
    title: "🇨🇦Day1_加拿大｜多倫多(Toronto)：首次踏上美洲大陸",
    url: "https://medium.com/cyen6/day1-2019-9-7-%E5%8F%B0%E5%8C%97-%E6%9D%B1%E4%BA%AC-%E6%B4%9B%E6%9D%89%E7%A3%AF-%E5%A4%9A%E5%80%AB%E5%A4%9A-5019458b169c",
    country: ["Canada"],
  },
  {
    date: "2019.09.08",
    title: "🇨🇦Day2_加拿大｜多倫多(Toronto)：雷神之水",
    url: "https://medium.com/cyen6/day2-%E5%8A%A0%E6%8B%BF%E5%A4%A7-%E5%A4%9A%E5%80%AB%E5%A4%9A-toronto-%E9%9B%B7%E7%A5%9E%E4%B9%8B%E6%B0%B4-466c3bb3f70e",
    country: ["Canada"],
  },
  {
    date: "2019.09.09",
    title: "🇨🇦Day3_加拿大｜多倫多(Toronto)：國王學院",
    url: "https://medium.com/cyen6/day3-%E5%8A%A0%E6%8B%BF%E5%A4%A7-%E5%A4%9A%E5%80%AB%E5%A4%9A-%E5%9C%8B%E7%8E%8B%E5%AD%B8%E9%99%A2-8c4938311e95",
    country: ["Canada"],
  },
  {
    date: "2019.09.10",
    title: "🇨🇦Day4_加拿大｜多倫多(Toronto)：大聯盟初體驗",
    url: "https://medium.com/cyen6/day4-%E5%8A%A0%E6%8B%BF%E5%A4%A7-%E5%A4%9A%E5%80%AB%E5%A4%9A-toronto-%E5%A4%A7%E8%81%AF%E7%9B%9F%E5%88%9D%E9%AB%94%E9%A9%97-79e46f781315",
    country: ["Canada"],
  },
  {
    date: "2019.09.11",
    title: "🇨🇦Day5_加拿大｜多倫多(Toronto)：海貍尾巴",
    url: "https://medium.com/cyen6/day5-%E5%8A%A0%E6%8B%BF%E5%A4%A7-%E5%A4%9A%E5%80%AB%E5%A4%9A-toronto-%E6%B5%B7%E8%B2%8D%E5%B0%BE%E5%B7%B4-98586e21e1b",
    country: ["Canada"],
  },
  {
    date: "2019.09.12",
    title:
      "🇨🇦Day6_加拿大｜多倫多(Toronto) — 🇺🇸美國｜紐約(New York)：The Big Apple",
    url: "https://medium.com/cyen6/day6-%E5%8A%A0%E6%8B%BF%E5%A4%A7-%E5%A4%9A%E5%80%AB%E5%A4%9A-toronto-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-the-big-apple-cf1d0f903160",
    country: ["Canada", "United States of America"],
  },
  {
    date: "2019.09.13",
    title: "🇺🇸Day7_美國｜紐約(New York)：大都會博物館",
    url: "https://medium.com/cyen6/day7-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-%E5%A4%A7%E9%83%BD%E6%9C%83%E5%8D%9A%E7%89%A9%E9%A4%A8-112003f027f5",
    country: ["United States of America"],
  },
  {
    date: "2019.09.14",
    title: "🇺🇸Day8_美國｜紐約(New York)：首度摘星星",
    url: "https://medium.com/cyen6/day8-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-%E9%A6%96%E5%BA%A6%E6%91%98%E6%98%9F%E6%98%9F-d5d80ba63f8d",
    country: ["United States of America"],
  },
  {
    date: "2019.09.15",
    title: "🇺🇸Day9_美國｜紐約(New York)：洋基球場巡禮",
    url: "https://medium.com/cyen6/day9-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-%E6%B4%8B%E5%9F%BA%E7%90%83%E5%A0%B4%E5%B7%A1%E7%A6%AE-f922bbc99994",
    country: ["United States of America"],
  },
  {
    date: "2019.09.16",
    title: "🇺🇸Day10_美國｜紐約(New York)：美國巴別塔",
    url: "https://medium.com/cyen6/day10-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-%E7%BE%8E%E5%9C%8B%E5%B7%B4%E5%88%A5%E5%A1%94-2f51f4bcb7fb",
    country: ["United States of America"],
  },
  {
    date: "2019.09.17",
    title: "🇺🇸Day11_美國｜紐約(New York)：自由女神",
    url: "https://medium.com/cyen6/day11-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-%E8%87%AA%E7%94%B1%E5%A5%B3%E7%A5%9E-98e78e0daf42",
    country: ["United States of America"],
  },
  {
    date: "2019.09.18-19",
    title: "🇺🇸Day12–13_美國｜紐約(New York) — 🇯🇵日本｜東京(Tokyo)：上班族之夜",
    url: "https://medium.com/cyen6/day12-13-%E7%BE%8E%E5%9C%8B-%E7%B4%90%E7%B4%84-new-york-%E6%97%A5%E6%9C%AC-%E6%9D%B1%E4%BA%AC-tokyo-%E4%B8%8A%E7%8F%AD%E6%97%8F%E4%B9%8B%E5%A4%9C-92e1149a10b0",
    country: ["United States of America", "Japan"],
  },
  {
    date: "2019.09.20",
    title: "🇯🇵Day14_日本｜鎌倉(Kamakura)：鎌倉的無敵海景",
    url: "https://medium.com/cyen6/day14-%E6%97%A5%E6%9C%AC-%E9%8E%8C%E5%80%89-kamakura-%E9%8E%8C%E5%80%89%E7%9A%84%E7%84%A1%E6%95%B5%E6%B5%B7%E6%99%AF-3bfd95d842e5",
    country: ["Japan"],
  },
  {
    date: "2019.09.21",
    title: "🇯🇵Day15_日本｜東京(Tokyo)：根津神社的天下祭",
    url: "https://medium.com/cyen6/day15-%E6%97%A5%E6%9C%AC-%E6%9D%B1%E4%BA%AC-tokyo-%E6%A0%B9%E6%B4%A5%E7%A5%9E%E7%A4%BE%E7%9A%84%E5%A4%A9%E4%B8%8B%E7%A5%AD-af7d6566f2e1",
    country: ["Japan"],
  },
  {
    date: "2019.09.22",
    title: "🇯🇵Day16_日本｜東京(Tokyo)：稻草人競賽",
    url: "https://medium.com/cyen6/day16-%E6%97%A5%E6%9C%AC-%E6%9D%B1%E4%BA%AC-tokyo-%E7%A8%BB%E8%8D%89%E4%BA%BA%E7%AB%B6%E8%B3%BD-231ebe6f842a",
    country: ["Japan"],
  },
];

export const countries = [
  "Taiwan",
  "Japan",
  "Cambodia",
  "Vietnam",
  "China",
  "Myanmar",
  "Thailand",
  "Canada",
  "United States of America",
  "Germany",
  "Austria",
  "Czechia",
];
